import Link from "next/link";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";
import type { FeatureCard as FeatureCardType } from "@/lib/data/features";

interface FeatureCardProps {
  feature: FeatureCardType;
}

export function FeatureCard({ feature }: FeatureCardProps) {
  const Icon = feature.icon;

  return (
    <Link href={feature.href} className="group block">
      <Card className="flex flex-col items-center gap-1.5 border-none bg-gray-100/70 p-3 shadow-sm transition-all duration-200 hover:-translate-y-0.5 hover:shadow-md dark:bg-gray-800 sm:gap-2 sm:p-4 md:gap-3 md:p-6">
        {/* Icon container with colorful background */}
        <div
          className={cn(
            "flex h-10 w-10 shrink-0 items-center justify-center rounded-full transition-transform duration-200 group-hover:scale-110 sm:h-12 sm:w-12 md:h-14 md:w-14",
            feature.bgColor,
            // Dark mode - slightly more opaque/vibrant colors
            "dark:opacity-90",
          )}
        >
          <Icon
            className={cn(
              "h-5 w-5 sm:h-6 sm:w-6 md:h-7 md:w-7",
              feature.iconColor,
            )}
          />
        </div>

        {/* Label */}
        <span className="w-full break-keep text-center text-[10px] font-medium leading-tight text-gray-900 dark:text-gray-100 sm:text-xs md:text-sm">
          {feature.label}
        </span>
      </Card>
    </Link>
  );
}
